import gql from 'graphql-tag';

export default gql`
  query getPageBuilder($slug: String) {
    getPageBuilder(slug: $slug) {
      id
      img_desktop
      img_mobile
      blocks
      detail {
        id
        title
        slug
        meta_title
        meta_description
        meta_tags
        meta_og_title
        meta_og_description
        meta_og_url
        language_code
      }
    }
  }
`;

const getPageBuilderByType = gql`
  query getPageBuilder($type: String) {
    getPageBuilder(type: $type) {
      id
      img_desktop
      img_mobile
      blocks
      detail {
        id
        title
        slug
        meta_title
        meta_description
        meta_tags
        meta_og_title
        meta_og_description
        meta_og_url
        language_code
      }
    }
  }
`;

export { getPageBuilderByType };
